import React from 'react';

import cx from 'classnames';
import { RawDraftContentBlock } from 'draft-js';

import { Wysiwyg } from 'components/shared/Wysiwyg';
import { EBlockType, IBlock, IPoint, IRichText } from 'detailsv2/__blocks';
import { getBlock } from 'utils/blocksHelpers/__fixtures__/getBlock';

import { useBlockContext } from '../../../Block/context';
import { useReadonlyBlockClick } from '../../functions';
import { useCheckboxTemplate } from './functions';
import s from './index.module.css';

export const CheckpointsBlock = ({ gap = '14px' }: { gap?: string }) => {
  const { styles, pointsRef } = useCheckboxTemplate();
  const { block } = useBlockContext<IBlock<EBlockType.Checkpoints>>();
  const handleClick = useReadonlyBlockClick();

  return (
    <>
      <div className={cx(s.mainContainer, block.data.template === 'line' && s.line)} onClick={handleClick}>
        <div className={s.pointsContainer} ref={pointsRef} style={{ ...styles, gap }}>
          {block.data.points?.map((point, i) => {
            const firstElement = i === 0;
            const lastElement = i === block.data.points.length - 1;
            const isFirstOrLastElement = firstElement || lastElement;
            const data = createDraftData(point);

            return (
              <div key={point.text + i} className={cx(s.point)}>
                {block.data.template === 'point' && block.data.points.length > 1 && (
                  <div className={cx(s.greyPoint, !isFirstOrLastElement && s.hideGreyPoint)} />
                )}
                <div
                  className={cx(!isFirstOrLastElement && block.data.template === 'point' && s.addTextMargin)}
                  data-block
                >
                  {/* Switched to WYSIWYG because now points can have different styles for different parts of text */}
                  <Wysiwyg placeholder={point.text} data={data} isReadOnly onChange={() => {}} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const createDraftData = (point: IPoint): IRichText => {
  return {
    text: point.text,
    raw: {
      entityMap: point.entityMap || {},
      blocks: [getBlock(point)] as RawDraftContentBlock[],
    },
  };
};
